import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class EventMappingSearchCriteria extends ValueObject {
    public searchCriteria: string = "";

    public isCashNotCapitalisedExclInd: boolean = false;

    public isCapitalGainEventInd: boolean = false;

    public isCashFlowInd: boolean = false;

    public isQuantityNotValueInd: boolean = false;

    public isDividendEventInd: boolean = false;

    public isSellAtBookCostEventInd: boolean = false;

    public isBuyAtBookCostEventInd: boolean = false;

    public isZeroPriceEventInd: boolean = false;

    public isDWTInd: boolean = false;

    public isInterestInd: boolean = false;

    public isCorporateActionInd: boolean = false;

    public isProcessedAsNegativeBuyInd: boolean = false;

    public isTransferInd: boolean = false;

    public isIWTInd: boolean = false;

    public excludeFromExport: boolean = false;

    public isCorporateActionReferenceRequired: boolean = false;
}